import {
  footer_styles_default
} from "./chunk.F6VJ7DYO.js";
import {
  container_styles_default
} from "./chunk.USJQKTI6.js";
import {
  ApplicationSection
} from "./chunk.3TZLHWFR.js";
import {
  HasSlotController
} from "./chunk.CLKP6Z3C.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/footer/footer.ts
var FadvFooter = class extends ApplicationSection {
  constructor() {
    super(...arguments);
    this.variant = "default";
    this.hasSlotController = new HasSlotController(this, "item", "copyright");
  }
  renderCopyright() {
    if (this.copyright || this.hasSlotController.test("copyright"))
      return $`<slot name="copyright"><fadv-typography type="label-x-small" weight="500" copyright="${this.copyright}" class="footer__copyright-${this.variant}">${this.copyright}</fadv-typography></slot>`;
    return w;
  }
  render() {
    return $`<div class=${o({
      footer: true,
      "footer--default": this.variant === "default",
      "footer--primary": this.variant === "primary",
      "footer--transparent": this.variant === "transparent",
      "footer--has-items": this.hasSlotController.test("item"),
      "footer--has-copyright": this.copyright || this.hasSlotController.test("copyright")
    })} part="base" ><div class=${o({
      container: !this.breakpoint && !this.applicationBreakpoint,
      "container-sm": this.hasBreakpoint("sm"),
      "container-md": this.hasBreakpoint("md"),
      "container-lg": this.hasBreakpoint("lg"),
      "container-xl": this.hasBreakpoint("xl"),
      "container-xxl": this.hasBreakpoint("xxl"),
      "container-fluid": this.hasBreakpoint("fluid")
    })} ><slot></slot><slot name="item"></slot><div class="footer__copyright">${this.renderCopyright()}</div></div></div>`;
  }
};
FadvFooter.styles = [container_styles_default, footer_styles_default];
__decorateClass([
  e({ reflect: true })
], FadvFooter.prototype, "variant", 2);
__decorateClass([
  e({ reflect: true })
], FadvFooter.prototype, "copyright", 2);
FadvFooter = __decorateClass([
  n("fadv-footer")
], FadvFooter);

export {
  FadvFooter
};
